var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col space-y-2"},_vm._l((_vm.options),function(button){return _c('button',{key:button.id,staticClass:"w-full px-4 py-3 border rounded text-sm text-center font-semibold",class:{
            'bg-gray-50 border hover:bg-blue-light hover:border-blue': button.id !== _vm.value,
            'bg-blue-light border-blue': button.id === _vm.value
        },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', button.id)}}},[_vm._v("\n        "+_vm._s(button.label)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }